import React from 'react';
import './InfoBlock.css';

const InfoBlock = ({ section, isRightAligned }) => {
  if (!section) return null;

  const backendUrl = process.env.REACT_APP_BACKEND_URL || 'http://localhost:3030';
  
  const alignClass = isRightAligned ? "section-header-right mb-5 pb-4 pt-5" : "mb-5 pb-4 pt-5";
  const revealDirection = isRightAligned ? "reveal-from-left" : "reveal-from-right";

  const dynamicStyle = {
    position: 'relative',
    overflow: 'hidden'
  };

  if (section.background_type === 'color' || (!section.background_image_url && section.background_color)) {
    dynamicStyle.backgroundColor = section.background_color;
  }
  const opacityValue = (section.background_opacity || 100) / 100;

  return (
    <section id={section.slug} className="py-5 infoblock-section" style={dynamicStyle}>
      {/* CAMADA 0: Fundo */}
      {section.background_type === 'image' && section.background_image_url && (
        <div className="bg-parallax" style={{
          position: 'absolute', top: 0, left: 0, width: '100%', height: '100%',
          backgroundImage: `url(${backendUrl}${section.background_image_url})`,
          backgroundSize: 'cover', backgroundPosition: 'center', zIndex: 0
        }}></div>
      )}

      {/* CAMADA 1: Overlay */}
      {section.background_type === 'image' && section.background_image_url && (
        <div style={{
          position: 'absolute', top: 0, left: 0, width: '100%', height: '100%',
          backgroundColor: 'rgba(255, 255, 255, 0.99)',
          opacity: opacityValue,
          zIndex: 1
        }}></div>
      )}

      {/* CAMADA 2: Conteúdo */}
      <div className="container pt-4" style={{ position: 'relative', zIndex: 2 }}>
        <div className={alignClass}>
          <h2 className={`fonte-primaria display-4 section-title reveal-element ${revealDirection} duration-10`}>
            {section.title}
          </h2>
          <h4 className={`fonte-terciaria section-subtitle mb-4 reveal-element ${revealDirection} duration-12`}>
            {section.subtitle}
          </h4>
          {section.content && (
            <p className={`fonte-terciaria lead text-dark reveal-element ${revealDirection} duration-14`} style={{ whiteSpace: 'pre-line' }}>
              {section.content}
            </p>
          )}
        </div>
      </div>
    </section>
  );
};

export default InfoBlock;